import Vue from 'vue'
import Vuex from 'vuex'

import state from './state'
import getters from './getters'
import mutations from './mutations'
import actions from './actions'
import plugins from './plugins'

Vue.use(Vuex)

export default new Vuex.Store({
  state,
  getters,
  mutations,
  actions,
  plugins,
  strict: process.env.NODE_ENV !== 'production',
  modules: {
    // assetpkg,
    // setting
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js